import React from "react";
import PropTypes from "prop-types";
import FormTextEntry from "./FormTextEntry";
import FormTextAreaEntry from "./FormTextAreaEntry";
import StaticText from "./StaticText";
import FormRadioEntry from "./FormRadioEntry";
import FormTableEntry from "./FormTableEntry";
import FormHiddenEntry from "./FormHiddenEntry";
import HelperContent from "../helperContent/HelperContent";
import QuestionLabel from "../question/QuestionLabel";
import QuestionOption from "../question/QuestionOption";
import strings from "../../resources/strings";


const showPlaceholder = field => {
    return field.required ? strings.getString("required") : "";
};

const Form = ({ question = {}, store = {}, answers = [], onSave = f => f }) => {
    let options = question.options;
    let optionsCode = null;

    if (options && options.length > 0) {
        optionsCode = (
            <ul className="w3-ul w3-border w3-padding-small w3-margin-top">
                {options.map(option => (
                    <li className="question-option w3-xlarge w3-center" key={option.itemID}>
                        <QuestionOption option={option} onClick={() => store.dispatch({ type: option.action, selectedOption: option })} />
                    </li>
                ))}
            </ul>
        );
    }

    return (
        <div className="form w3-header w3-animate-opacity">
            <QuestionLabel question={question} store={store}/>
            <HelperContent question={question}/>
            <div className="fields">
                {answers.map((field, i) => {
                    let defaultValue = "";
                    let autocompleteParam;
                    
                    if ("autocomplete" in field) {
                        autocompleteParam = {autocomplete: field.autocomplete};
                    }

                    if (answers && answers[i] && answers[i].value
                            && typeof answers[i].value === 'string'
                            && answers[i].value.startsWith("${")
                            && answers[i].value.endsWith("}"))
                    {
                        let val = answers[i].value;
                        let variableName = val.substring(val.indexOf("{") + 1, val.lastIndexOf("}"));
                        answers[i].value = store.getState()[variableName];
                    }

                    if (field.fieldType === "text" || field.fieldType === "number" || field.fieldType === "email"
                            || field.fieldType === "date" || field.fieldType === "tel")
                    {
                        return (
                            <FormTextEntry
                                key={i}
                                label={field.label}
                                fieldType={field.fieldType}
                                placeholder={showPlaceholder(field)}
                                name={field.fieldID}
                                {...autocompleteParam}
                                saveChanges={onSave}
                                disabled={field.disabled}
                                value={answers && answers[i] ? answers[i].value : defaultValue}
                            />
                        );
                    } else if (field.fieldType === "textarea") {
                        return (
                            <FormTextAreaEntry
                                key={i}
                                label={field.label}
                                name={field.fieldID}
                                {...autocompleteParam}
                                saveChanges={onSave}
                                value={answers && answers[i] ? answers[i].value : defaultValue}
                            />
                        );
                    } else if (field.fieldType === "statictext") {
                        return (
                            <StaticText
                                key={i}
                                label={field.label}
                                name={field.fieldID}
                                value={answers && answers[i] ? answers[i].value : defaultValue}
                            />
                        );
                    } else if (field.fieldType === "radio") {
                        return (
                            <FormRadioEntry
                                key={i}
                                label={field.label}
                                name={field.fieldID}
                                options={field.radioOptions}
                                saveChanges={onSave}
                                value={answers && answers[i] ? answers[i].value : defaultValue}
                            />
                        );
                    } else if (field.fieldType === "hidden") {
                        // hidden fields are used to carry data into the workflowData object that we do
                        // not want displayed. For example, fields being returned from a weber call that
                        // we just want to store. We need to carry it through to form in order to have it
                        // stored when the form is submitted.
                        return (
                            <FormHiddenEntry
                                key={i}
                                name={field.fieldID}
                                saveChanges={onSave}
                                value={answers && answers[i] ? answers[i].value : defaultValue}
                            />
                        );
                    } else if (field.fieldType === "table") {
                        let columns = answers[i] && answers[i].columns;
                        let data = answers[i] && answers[i].data;

                        if (!columns || !data) return null;

                        return <FormTableEntry key={i} columns={columns} data={data} />;
                    } else if (field.fieldType === "array") {
                        // ignore it, this can happen if no results to replace answerFields with text filed in 
                        // questionAssignment.assignFormField(), due to extraction not returning items for array
                        return null;
                    } else {
                        return <div key={i}>Unsupported field type: {field.fieldType}</div>;
                    }
                })}
            </div>
            <div className="question-options">{optionsCode}</div>
        </div>
    );
};

Form.propTypes = {
    question: PropTypes.object,
    answers: PropTypes.array,
    onSave: PropTypes.func
};

export default Form;
